import React from "react";
import styles from "./HeadingBelowNumber.module.css";

const HeadingBelowNumber = ({
  heading,
  number,
  bgColor = "rgba(0, 0, 0, 0.05)", // default
  textColor = "Black_Color",
}) => {
  return (
    <div className={styles.container} style={{ backgroundColor: bgColor }}>
      <p className={styles.heading}>{heading}</p>
      <p className={styles.number} style={{ color: `var(--${textColor})` }}>
        INR {number}
      </p>
    </div>
  );
};

export default HeadingBelowNumber;
